<template>
  <div
    data-hover="slider"
    @click="nextProject()"
    class="home-slider-grid grid-x align-middle"
    :class="{'has-index': hasIndex}"
  >
    <div
      v-if="slide[imageKey] && slide[imageKey].file"
      class="background"
      :style="{'background-image':'url(\'' + resourceUrl + slide[imageKey].file.path + '\')'}"
    ></div>
    <router-link
      v-if="slide.type !== 'blank'"
      tag="div"
      data-hover="link"
      class="cell small-12 large-6"
      :to="toRef"
    >
      <home-slider-content :link="toRef" :slide="slide" />
    </router-link>
    <a v-else data-hover="link" :href="slide.ref" target="_blank" class="cell small-12 large-6">
      <home-slider-content :slide="slide" />
    </a>
  </div>
</template>

<script>
import HomeSliderContent from "./HomeSliderContent";
export default {
  name: "HomeIntro",
  components: {
    "home-slider-content": HomeSliderContent
  },
  props: {
    slide: {
      default: {}
    },
    isMobile: {
      default: false
    },
    hasIndex: {
      default: false
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES
    };
  },
  methods: {
    nextProject() {
      this.$store.commit("rotateCursor");
      this.$parent.nextProject();
    }
  },
  computed: {
    imageKey() {
      return this.isMobile ? "mobileImage" : "mainImage";
    },
    toRef() {
      console.log(this.slide.type, this.slide.ref);
      if (this.slide.type === "page") {
        return {
          name: "page",
          params: { page: this.slide.ref }
        };
      } else {
        if (this.slide.ref) {
          return `/${this.$i18n.locale}/${this.$t("nav.cosa.slug")}/${
            this.slide.ref
          }`;
        } else {
          return `/${this.$i18n.locale}/${this.$t("nav.cosa.slug")}`;
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "@assets/scss/_importer.scss";
.home-slider-grid {
  overflow: hidden;
  height: 100vh;
  @include breakpoint(large up) {
    padding: 64px;
  }

  @include breakpoint(medium down) {
    padding: 0 32px;
  }
  &.has-index {
    @include breakpoint(medium down) {
      height: calc(100vh - 64px);
    }
  }
  @include breakpoint(small only) {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
    padding-bottom: 64px;
  }
  position: relative;
  z-index: 1;
  .background {
    z-index: -1;
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 64px;
    left: 64px;
    height: calc(100vh - 128px);
    width: calc(100% - 128px);
    @include breakpoint(medium down) {
      height: 100vh;
      width: 100vw;
      top: 0;
      left: 0;
    }
  }
  .cell {
    @include breakpoint(large up) {
      width: calc(50% - 256px) !important;
      margin-left: 128px;
    }
    &:hover {
      /deep/ p.readmore a {
        text-decoration: none;
      }
    }
  }
}
.blank-wrap {
  display: block;
}
</style>
